import { __assign, __rest } from "tslib";
import React from 'react';
import { ConfigContext } from './config-context';
var ConfigProvider = function (props) {
    var children = props.children, otherProps = __rest(props, ["children"]);
    return React.createElement(ConfigContext.Provider, { value: __assign({}, otherProps) }, children);
};
ConfigProvider.displayName = 'ConfigProvider';
export default ConfigProvider;
//# sourceMappingURL=index.js.map